<template lang="pug">
.d-flex.flex-row.justify-content-start.align-items-center
    h1
        i(:class='iconeTituloTabela')
        span.tabela-titulo {{ tituloTabela }}
</template>

<script>
export default {
    name: 'BaseTableHeader',

    props: {
        tituloTabela: {
            type: String,
            required: true,
            default: 'Tabela'
        },
        iconeTituloTabela: {
            type: String,
            required: true,
            default: 'mdi mdi-cloud-search-outline'
        }
    }
};
</script>
